function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M.59.59a.833.833 0 011.178 0l10.607 10.606a.833.833 0 01-1.179 1.178L.59 1.768a.833.833 0 010-1.179z"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M.59 12.374a.833.833 0 010-1.178L11.195.589a.833.833 0 111.178 1.179L1.768 12.374a.833.833 0 01-1.179 0z"
});
function SvgCrossSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 13 13"
  }, props), _ref, _ref2);
}
export default SvgCrossSmall;